<div class="flex flex-col items-center gap-3">
  <div class="flex w-full items-center">
    <app-chart-doughnut
      [data]="chartData()"
      [size]="chartSize.getSize('reductionTips')"
      [thickness]="chartSize.getThickness('reductionTips')"
      [centerValue]="centerValue()"
      [centerLabel]="centerLabel()"
      [showLabelInTooltip]="true"
    />

    <!-- Largeur figee : la valeur barree et la part grise qui apparaissent a
         la selection ne doivent pas elargir le panneau. -->
    <div class="w-[380px] shrink-0">
      @for (item of displayLegend(); track item.type) {
        <app-impact-legend-item
          [item]="item"
          [previousImpact]="item.previousImpact"
          [showPercentage]="false"
        />
      }
    </div>
  </div>

  <div class="w-full rounded-lg border border-primary-200 bg-primary-50 p-4">
    @if (hasSelection()) {
      <dl class="space-y-1">
        <div class="flex items-baseline justify-between gap-4">
          <dt class="text-paragraph-s-reg text-greyscale-600">
            {{ "reductionTips.simulation.baseline" | transloco }}
          </dt>
          <dd
            class="text-paragraph-s-reg font-medium tabular-nums text-primary-900"
          >
            {{ co2e(displayBaseTotal()) }}
          </dd>
        </div>
        <div class="flex items-baseline justify-between gap-4">
          <dt class="text-paragraph-s-reg text-greyscale-600">
            {{ "reductionTips.simulation.avoided" | transloco }}
          </dt>
          <dd
            class="text-paragraph-s-reg font-semibold tabular-nums text-validation-600"
          >
            −{{ co2e(displayAvoided()) }} (−{{ avoidedPercent() }}%)
          </dd>
        </div>
        <div
          class="flex items-baseline justify-between gap-4 border-t border-primary-200 pt-1"
        >
          <dt class="text-paragraph-s-reg font-medium text-primary-900">
            {{ "reductionTips.simulation.newTotal" | transloco }}
          </dt>
          <dd
            class="text-paragraph-reg font-semibold tabular-nums text-primary-900"
          >
            {{ co2e(displayNewTotal()) }}
          </dd>
        </div>
      </dl>
    } @else {
      <p class="text-center text-paragraph-s-reg text-greyscale-600">
        {{ "reductionTips.simulation.empty" | transloco }}
      </p>
    }
  </div>

  <div class="flex w-full flex-col items-center gap-1">
    <p-button
      [label]="'reductionTips.simulation.apply' | transloco"
      size="small"
      styleClass="w-full"
      [disabled]="!hasSelection() || reductionTipsService.isApplying()"
      [loading]="reductionTipsService.isApplying()"
      (onClick)="reductionTipsService.applyTips()"
    />
  </div>
</div>
